module.exports = __webpack_public_path__ + "media/application/images/company/founders-bw/Alfred-Odell-cfba01bcff7cde6acb6b5f7864c61ec4.jpg";